import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
    title: string;
    description: string;
    pathname?: string;
    image?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, pathname = '', image = 'https://www.learncmd.io/og-image.jpg' }) => {
    const siteUrl = 'https://www.learncmd.io';
    const canonical = pathname ? `${siteUrl}${pathname}` : siteUrl;

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'LearnCMD',
        url: siteUrl,
        description: description,
        potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}/search?q={search_term_string}`,
            'query-input': 'required name=search_term_string'
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(jsonLd)}
            </script>
            <link rel="canonical" href={canonical} />
        </Helmet>
    );
};

export default SEO; 